// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gitpod/v1/secret.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_gitpod_tools_v1_logfields } from "../tools/v1/logfields_pb";
import { file_gitpod_tools_v1_stainless } from "../tools/v1/stainless_pb";
import type { Subject } from "./identity_pb";
import { file_gitpod_v1_identity } from "./identity_pb";
import type { PaginationRequest, PaginationResponse } from "./pagination_pb";
import { file_gitpod_v1_pagination } from "./pagination_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gitpod/v1/secret.proto.
 */
export const file_gitpod_v1_secret: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_gitpod_tools_v1_logfields, file_gitpod_tools_v1_stainless, file_gitpod_v1_identity, file_gitpod_v1_pagination, file_google_protobuf_timestamp]);

/**
 * @generated from message gitpod.v1.CreateSecretRequest
 */
export type CreateSecretRequest = Message<"gitpod.v1.CreateSecretRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * project_id is the ProjectID this Secret belongs to
   * Deprecated: use scope instead
   *
   * @generated from field: string project_id = 2 [deprecated = true];
   * @deprecated
   */
  projectId: string;

  /**
   * value is the plaintext value of the secret
   *
   * @generated from field: string value = 3;
   */
  value: string;

  /**
   * mount specifies how the secret should be mounted in Environments
   *
   * @generated from oneof gitpod.v1.CreateSecretRequest.mount
   */
  mount: {
    /**
     * absolute path to the file where the secret is mounted
     *
     * @generated from field: string file_path = 7;
     */
    value: string;
    case: "filePath";
  } | {
    /**
     * secret will be created as an Environment Variable with the same name as the secret
     *
     * @generated from field: bool environment_variable = 8;
     */
    value: boolean;
    case: "environmentVariable";
  } | {
    /**
     * secret will be mounted as a docker config in the environment VM, mount will have the docker registry host
     *
     * @generated from field: string container_registry_basic_auth_host = 9;
     */
    value: string;
    case: "containerRegistryBasicAuthHost";
  } | {
    /**
     * api_only indicates the secret is only available via API/CLI.
     * These secrets are NOT automatically injected into services or devcontainers.
     * Useful for secrets that should only be consumed programmatically (e.g., by security agents).
     *
     * @generated from field: bool api_only = 11;
     */
    value: boolean;
    case: "apiOnly";
  } | { case: undefined; value?: undefined };

  /**
   * scope is the scope of the secret
   *
   * @generated from field: gitpod.v1.SecretScope scope = 10;
   */
  scope?: SecretScope;
};

/**
 * Describes the message gitpod.v1.CreateSecretRequest.
 * Use `create(CreateSecretRequestSchema)` to create a new message.
 */
export const CreateSecretRequestSchema: GenMessage<CreateSecretRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_secret, 0);

/**
 * @generated from message gitpod.v1.CreateSecretResponse
 */
export type CreateSecretResponse = Message<"gitpod.v1.CreateSecretResponse"> & {
  /**
   * @generated from field: gitpod.v1.Secret secret = 1;
   */
  secret?: Secret;
};

/**
 * Describes the message gitpod.v1.CreateSecretResponse.
 * Use `create(CreateSecretResponseSchema)` to create a new message.
 */
export const CreateSecretResponseSchema: GenMessage<CreateSecretResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_secret, 1);

/**
 * @generated from message gitpod.v1.UpdateSecretValueRequest
 */
export type UpdateSecretValueRequest = Message<"gitpod.v1.UpdateSecretValueRequest"> & {
  /**
   * @generated from field: string secret_id = 1;
   */
  secretId: string;

  /**
   * value is the plaintext value of the secret
   *
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message gitpod.v1.UpdateSecretValueRequest.
 * Use `create(UpdateSecretValueRequestSchema)` to create a new message.
 */
export const UpdateSecretValueRequestSchema: GenMessage<UpdateSecretValueRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_secret, 2);

/**
 * @generated from message gitpod.v1.UpdateSecretValueResponse
 */
export type UpdateSecretValueResponse = Message<"gitpod.v1.UpdateSecretValueResponse"> & {
};

/**
 * Describes the message gitpod.v1.UpdateSecretValueResponse.
 * Use `create(UpdateSecretValueResponseSchema)` to create a new message.
 */
export const UpdateSecretValueResponseSchema: GenMessage<UpdateSecretValueResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_secret, 3);

/**
 * @generated from message gitpod.v1.ListSecretsRequest
 */
export type ListSecretsRequest = Message<"gitpod.v1.ListSecretsRequest"> & {
  /**
   * pagination contains the pagination options for listing environments
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: gitpod.v1.ListSecretsRequest.Filter filter = 2;
   */
  filter?: ListSecretsRequest_Filter;
};

/**
 * Describes the message gitpod.v1.ListSecretsRequest.
 * Use `create(ListSecretsRequestSchema)` to create a new message.
 */
export const ListSecretsRequestSchema: GenMessage<ListSecretsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_secret, 4);

/**
 * @generated from message gitpod.v1.ListSecretsRequest.Filter
 */
export type ListSecretsRequest_Filter = Message<"gitpod.v1.ListSecretsRequest.Filter"> & {
  /**
   * project_ids filters the response to only Secrets used by these Project IDs
   * Deprecated: use scope instead. Values in project_ids will be ignored.
   *
   * @generated from field: repeated string project_ids = 1 [deprecated = true];
   * @deprecated
   */
  projectIds: string[];

  /**
   * scope is the scope of the secrets to list
   *
   * @generated from field: gitpod.v1.SecretScope scope = 2;
   */
  scope?: SecretScope;
};

/**
 * Describes the message gitpod.v1.ListSecretsRequest.Filter.
 * Use `create(ListSecretsRequest_FilterSchema)` to create a new message.
 */
export const ListSecretsRequest_FilterSchema: GenMessage<ListSecretsRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_secret, 4, 0);

/**
 * @generated from message gitpod.v1.ListSecretsResponse
 */
export type ListSecretsResponse = Message<"gitpod.v1.ListSecretsResponse"> & {
  /**
   * pagination contains the pagination options for listing secrets
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.Secret secrets = 2;
   */
  secrets: Secret[];
};

/**
 * Describes the message gitpod.v1.ListSecretsResponse.
 * Use `create(ListSecretsResponseSchema)` to create a new message.
 */
export const ListSecretsResponseSchema: GenMessage<ListSecretsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_secret, 5);

/**
 * @generated from message gitpod.v1.DeleteSecretRequest
 */
export type DeleteSecretRequest = Message<"gitpod.v1.DeleteSecretRequest"> & {
  /**
   * @generated from field: string secret_id = 1;
   */
  secretId: string;
};

/**
 * Describes the message gitpod.v1.DeleteSecretRequest.
 * Use `create(DeleteSecretRequestSchema)` to create a new message.
 */
export const DeleteSecretRequestSchema: GenMessage<DeleteSecretRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_secret, 6);

/**
 * @generated from message gitpod.v1.DeleteSecretResponse
 */
export type DeleteSecretResponse = Message<"gitpod.v1.DeleteSecretResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeleteSecretResponse.
 * Use `create(DeleteSecretResponseSchema)` to create a new message.
 */
export const DeleteSecretResponseSchema: GenMessage<DeleteSecretResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_secret, 7);

/**
 * @generated from message gitpod.v1.GetSecretValueRequest
 */
export type GetSecretValueRequest = Message<"gitpod.v1.GetSecretValueRequest"> & {
  /**
   * @generated from field: string secret_id = 1;
   */
  secretId: string;
};

/**
 * Describes the message gitpod.v1.GetSecretValueRequest.
 * Use `create(GetSecretValueRequestSchema)` to create a new message.
 */
export const GetSecretValueRequestSchema: GenMessage<GetSecretValueRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_secret, 8);

/**
 * @generated from message gitpod.v1.GetSecretValueResponse
 */
export type GetSecretValueResponse = Message<"gitpod.v1.GetSecretValueResponse"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;
};

/**
 * Describes the message gitpod.v1.GetSecretValueResponse.
 * Use `create(GetSecretValueResponseSchema)` to create a new message.
 */
export const GetSecretValueResponseSchema: GenMessage<GetSecretValueResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_secret, 9);

/**
 * @generated from message gitpod.v1.SecretScope
 */
export type SecretScope = Message<"gitpod.v1.SecretScope"> & {
  /**
   * @generated from oneof gitpod.v1.SecretScope.scope
   */
  scope: {
    /**
     * project_id is the Project ID this Secret belongs to
     *
     * @generated from field: string project_id = 1;
     */
    value: string;
    case: "projectId";
  } | {
    /**
     * user_id is the User ID this Secret belongs to
     *
     * @generated from field: string user_id = 2;
     */
    value: string;
    case: "userId";
  } | {
    /**
     * organization_id is the Organization ID this Secret belongs to
     *
     * @generated from field: string organization_id = 3;
     */
    value: string;
    case: "organizationId";
  } | {
    /**
     * service_account_id is the Service Account ID this Secret belongs to
     *
     * @generated from field: string service_account_id = 4;
     */
    value: string;
    case: "serviceAccountId";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.SecretScope.
 * Use `create(SecretScopeSchema)` to create a new message.
 */
export const SecretScopeSchema: GenMessage<SecretScope> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_secret, 10);

/**
 * @generated from message gitpod.v1.Secret
 */
export type Secret = Message<"gitpod.v1.Secret"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Name of the secret for humans.
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * The Project ID this Secret belongs to
   * Deprecated: use scope instead
   *
   * @generated from field: string project_id = 3 [deprecated = true];
   * @deprecated
   */
  projectId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;

  /**
   * creator is the identity of the creator of the secret
   *
   * @generated from field: gitpod.v1.Subject creator = 6;
   */
  creator?: Subject;

  /**
   * @generated from oneof gitpod.v1.Secret.mount
   */
  mount: {
    /**
     * absolute path to the file where the secret is mounted
     *
     * @generated from field: string file_path = 7;
     */
    value: string;
    case: "filePath";
  } | {
    /**
     * secret will be created as an Environment Variable with the same name as the secret
     *
     * @generated from field: bool environment_variable = 8;
     */
    value: boolean;
    case: "environmentVariable";
  } | {
    /**
     * secret will be mounted as a registry secret
     *
     * @generated from field: string container_registry_basic_auth_host = 9;
     */
    value: string;
    case: "containerRegistryBasicAuthHost";
  } | {
    /**
     * api_only indicates the secret is only available via API/CLI
     *
     * @generated from field: bool api_only = 11;
     */
    value: boolean;
    case: "apiOnly";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: gitpod.v1.SecretScope scope = 10;
   */
  scope?: SecretScope;
};

/**
 * Describes the message gitpod.v1.Secret.
 * Use `create(SecretSchema)` to create a new message.
 */
export const SecretSchema: GenMessage<Secret> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_secret, 11);

/**
 * @generated from service gitpod.v1.SecretService
 */
export const SecretService: GenService<{
  /**
   * Creates a new secret for a project.
   *
   * Use this method to:
   * - Store sensitive configuration values
   * - Set up environment variables
   * - Configure registry authentication
   * - Add file-based secrets
   *
   * ### Examples
   *
   * - Create environment variable:
   *
   *   Creates a secret that will be available as an environment variable.
   *
   *   ```yaml
   *   name: "DATABASE_URL"
   *   projectId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   value: "postgresql://user:pass@localhost:5432/db"
   *   environmentVariable: true
   *   ```
   *
   * - Create file secret:
   *
   *   Creates a secret that will be mounted as a file.
   *
   *   ```yaml
   *   name: "SSH_KEY"
   *   projectId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   value: "-----BEGIN RSA PRIVATE KEY-----\n..."
   *   filePath: "/home/gitpod/.ssh/id_rsa"
   *   ```
   *
   * - Create registry auth:
   *
   *   Creates credentials for private container registry.
   *
   *   ```yaml
   *   name: "DOCKER_AUTH"
   *   projectId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   value: "username:password"
   *   containerRegistryBasicAuthHost: "https://registry.example.com"
   *   ```
   *
   * @generated from rpc gitpod.v1.SecretService.CreateSecret
   */
  createSecret: {
    methodKind: "unary";
    input: typeof CreateSecretRequestSchema;
    output: typeof CreateSecretResponseSchema;
  },
  /**
   * Updates the value of an existing secret.
   *
   * Use this method to:
   * - Rotate secret values
   * - Update credentials
   *
   * ### Examples
   *
   * - Update secret value:
   *
   *   Changes the value of an existing secret.
   *
   *   ```yaml
   *   secretId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   value: "new-secret-value"
   *   ```
   *
   * @generated from rpc gitpod.v1.SecretService.UpdateSecretValue
   */
  updateSecretValue: {
    methodKind: "unary";
    input: typeof UpdateSecretValueRequestSchema;
    output: typeof UpdateSecretValueResponseSchema;
  },
  /**
   * Lists secrets
   *
   * Use this method to:
   * - View all project secrets
   * - View all user secrets
   *
   * ### Examples
   *
   * - List project secrets:
   *
   *   Shows all secrets for a project.
   *
   *   ```yaml
   *   filter:
   *     scope:
   *       projectId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * - List user secrets:
   *
   *   Shows all secrets for a user.
   *
   *   ```yaml
   *   filter:
   *     scope:
   *       userId: "123e4567-e89b-12d3-a456-426614174000"
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * @generated from rpc gitpod.v1.SecretService.ListSecrets
   */
  listSecrets: {
    methodKind: "unary";
    input: typeof ListSecretsRequestSchema;
    output: typeof ListSecretsResponseSchema;
  },
  /**
   * Deletes a secret permanently.
   *
   * Use this method to:
   * - Remove unused secrets
   * - Clean up old credentials
   *
   * ### Examples
   *
   * - Delete secret:
   *
   *   Permanently removes a secret.
   *
   *   ```yaml
   *   secretId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.SecretService.DeleteSecret
   */
  deleteSecret: {
    methodKind: "unary";
    input: typeof DeleteSecretRequestSchema;
    output: typeof DeleteSecretResponseSchema;
  },
  /**
   * Gets the value of a secret. Only available to environments that are authorized to access the secret.
   *
   * Use this method to:
   * - Retrieve secret values
   * - Access credentials
   *
   * ### Examples
   *
   * - Get secret value:
   *
   *   Retrieves the value of a specific secret.
   *
   *   ```yaml
   *   secretId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.SecretService.GetSecretValue
   */
  getSecretValue: {
    methodKind: "unary";
    input: typeof GetSecretValueRequestSchema;
    output: typeof GetSecretValueResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gitpod_v1_secret, 0);

